import { useNavigate } from 'react-router-dom';

export default function NavigationBar() {
    const navigate = useNavigate();
    return (
        <div style={{ textAlign: 'center', padding: '40px 20px', maxWidth: '600px', margin: '0 auto' }}>
            <nav>
                <button onClick={() => navigate('/')}>Home Page</button> | 
                <button onClick={() => navigate('/contact')}>Contact Us</button> |
                <button onClick={() => navigate('/register')}>Register</button> |
                <button onClick={() => navigate('/about')}>About Us</button> |
                <button onClick={() => navigate('/privacy')}>Privacy Policy</button> |
            </nav>
        </div>
    );
}